import { State } from 'xstate';

import { StateEvent } from '../constants/eventTypes';
import {
  ProductBuilderMachineContext,
  ProductBuilderMachineEvent,
  ProductBuilderMachineStateSchema,
} from '../types';
import { getEventFromState } from './getEventFromState';
import { getPreviousState } from './getPreviousState';
import { isInitialState } from './isInitialState';

type GoToPreviousState = (
  state: State<
    ProductBuilderMachineContext,
    ProductBuilderMachineEvent,
    ProductBuilderMachineStateSchema
  >,
  send: (event: StateEvent) => void,
) => () => void;

export const goToPreviousState: GoToPreviousState = (state, send) => () => {
  if (isInitialState(state)) return;
  const previousState = getPreviousState(state);
  const previousStateEvent = getEventFromState(previousState);
  send(previousStateEvent);
};
